// context/GlobalObjectContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import SettingsService from './SettingsService';
import { CompanySettings, UserSettings } from '../api/SettingsApi';
import { set } from 'lodash';

interface SettingsContextType {
    companySettings: CompanySettings | undefined;
    userSettings: UserSettings | undefined;
    loadingSettings: boolean;
    error: string | null;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [companySettings, setCompanySettings] = useState<CompanySettings>();
    const [userSettings, setUserSettings] = useState<UserSettings>();
    const [loadingSettings, setLoadingSettings] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const [loadingCompanySettings, setLoadingCompanySettings] = useState<boolean>(true);
    const [loadingUserSettings, setLoadingUserSettings] = useState<boolean>(true);

    useEffect(() => {
        const fetchCompanySettings = async () => {
            const service = SettingsService.getInstance();
            try {
                const companySettings = await service.loadCompanySettings();
                setCompanySettings(companySettings);
                setLoadingCompanySettings(false);

            } catch (err) {
                setError('Failed to fetch company settings');
                setLoadingCompanySettings(false);
            }
        };

        const fetchUserSettings = async () => {
            const service = SettingsService.getInstance();
            try {
                const userSettings = await service.loadUserSettings();
                setUserSettings(userSettings);
                setLoadingUserSettings(false);

            } catch (err) {
                setError('Failed to fetch user settings');
                setLoadingUserSettings(false);
            }
        };

        setLoadingSettings(true);
        setLoadingCompanySettings(false);
        setLoadingUserSettings(false);

        fetchCompanySettings();
        // fetchUserSettings();
    }, []);

    useEffect(() => {
        if (loadingCompanySettings && loadingUserSettings) {
            setLoadingSettings(false);
        }
    }, [loadingCompanySettings, loadingUserSettings]);

    return (
        <SettingsContext.Provider value={{ companySettings: companySettings, userSettings: userSettings, loadingSettings, error }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useGlobalObject must be used within a GlobalObjectProvider');
    }
    return context;
};